














































import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/components/layouts/ModuleLayout/ModuleLayout.vue';
import Header from '@/components/widgets/organisms/Header/Header.vue';
import Filters from './organisms/Filter/Filter.vue';
import AdvancedFilters from '@/components/widgets/organisms/AdvancedFilters/AdvancedFilters.vue';
import Table from '@/components/widgets/organisms/Table/Table.vue';
import Pagination from '@/components/widgets/organisms/Pagination/Pagination.vue';

import ReportModal from '@/components/modals/rancher/ReportModal/ReportModal.vue';
import MapModal from '@/components/modals/rancher/MapModal/MapModal.vue';
import CarouselModal from '@/components/modals/CarouselModal/CarouselModal.vue';
import TravelInterruptionModal from '@/components/modals/TravelInterruption/TravelInterruption.vue';

import { AvailableFilters } from '@/models/filters/available-filters.interface';
import { AdvancedFiltersDefinitions } from '@/models/filters/advanced-filters.interface';
import { formatDateHour, formatDateISO } from '@/shared/util/formatDate';
import formatMoney from '@/shared/util/formatMoney';
import formatNumber from '@/shared/util/formatNumber';
import { saveXLSX } from '@/helpers/ExportXLSX';
import { SYSTEM_PERMISSIONS } from '@/constants/permissions';

import {
	LOAD_TRAVEL_REQUEST,
	GET_DOWNLOAD_IMAGE,
	GET_COLUMNS,
	PUT_COLUMNS,
	SELECT_DETAIL_ORDER,
	SELECT_MAP,
	SELECT_TRAVEL_INTERRUPTION,
} from '@/store/travels/actions';

@Component({
	components: {
		Layout,
		Header,
		Filters,
		Table,
		Pagination,
		AdvancedFilters,
		ReportModal,
		CarouselModal,
		MapModal,
		TravelInterruptionModal,
	},
})
export default class RancherModuleTravel extends Vue {
	/* Data */
	private availableFilters: any = AvailableFilters;

	private isLoaded: boolean = true;

	private busy: any = {
		xlsx: false,
		image: false,
	};

	private totalPages: number = 0;

	private params: any = {
		page: 1,
		size: 16,
		dataInicio: '',
		dataFim: '',
		pedidoId: '',
		viagemId: '',
		pecuaristaOrigemId: '',
		pecuaristaDestinoId: '',
		fazendaOrigemId: '',
		fazendaDestinoId: '',
		rastreamentoTipoEventoId: '',
		codigoSituacaoOperacional: '',
		motoristaId: '',
		ocorrencia: '',
		placaCavalo: '',
		placaCarreta: '',
		colunas: [],
	};

	private fixedHeader: any = [
		{ key: 'pedido', label: 'Pedido', thClass: 'dark-header' },
		{ key: 'viagem', label: 'Viagem', thClass: 'dark-header' },
		{ key: 'status', label: 'Status', thClass: 'dark-header' },
		{ key: 'ocorrencias', label: 'Ocorrências', thClass: 'dark-header' },
		{
			key: 'actions',
			label: 'Ações',
			thClass: 'gray-header',
			tdClass: 'td-action',
		},
	];

	private header: any = [];

	private columns: Array<any> = [];

	private rows: any = [];

	/* Computed */
	get permissions() {
		return this.$store.getters.getUserPermissions;
	}

	get systemPermissions() {
		return SYSTEM_PERMISSIONS.RANCHER.TRAVEL;
	}

	/* Lifecycle */
	constructor() {
		super();
	}

	created() {
		this.getColumns();
	}

	/* Methods */
	submitAdvancedFilter(selectedAdvacedFilters: any) {
		this.params.colunas = selectedAdvacedFilters;
		this.$store
			.dispatch(PUT_COLUMNS, selectedAdvacedFilters)
			.then(() => {
				this.$toast.success('Filtros salvos!');
			})
			.catch(() => {
				this.$toast.error('Erro ao aplicar filtros!');
			});
		this.getTravels(this.params);
	}

	submitFilter(filterDefinition: any): void {
		Object.keys(filterDefinition).forEach(index => {
			const numberIndex = +index;
			switch (numberIndex) {
				case this.availableFilters.Date:
					this.params.dataInicio = formatDateISO(filterDefinition[numberIndex].startDateSelected);
					this.params.dataFim = formatDateISO(filterDefinition[numberIndex].endDateSelected);
					break;
				case this.availableFilters.Origin:
					this.params.pecuaristaOrigemId =
						filterDefinition[numberIndex].rancherSelected?.value || '';
					this.params.fazendaOrigemId = filterDefinition[numberIndex].farmSelected?.value || '';
					break;
				case this.availableFilters.Destiny:
					this.params.pecuaristaDestinoId =
						filterDefinition[numberIndex].rancherSelected?.value || '';
					this.params.fazendaDestinoId = filterDefinition[numberIndex].farmSelected?.value || '';
					break;
				case this.availableFilters.Tracking:
					this.params.rastreamentoTipoEventoId =
						filterDefinition[numberIndex].trackingSelected?.value || '';
					break;
				case this.availableFilters.Travel:
					this.params.viagemId = filterDefinition[numberIndex].travelSelected || '';
					break;
				case this.availableFilters.Order:
					this.params.pedidoId = filterDefinition[numberIndex].orderSelected;
					break;
				case this.availableFilters.Situation:
					this.params.codigoSituacaoOperacional =
						filterDefinition[numberIndex].situationSelected?.value || '';
					break;
				case this.availableFilters.Driver:
					this.params.motoristaId = filterDefinition[numberIndex].driverSelected?.value || '';
					break;
				case this.availableFilters.Truck:
					this.params.placaCavalo = filterDefinition[numberIndex]?.truckSelected || '';
					break;
				case this.availableFilters.Cart:
					this.params.placaCarreta = filterDefinition[numberIndex]?.cartSelected || '';
					break;
			}
		});
		this.params.page = 1;
		this.getTravels(this.params);
	}

	changePage(page) {
		this.params.page = page;
		this.getTravels(this.params);
	}

	changeSize(size) {
		this.params.size = size;
		this.params.page = 1;
		this.getTravels(this.params);
	}

	getTravels(params: any) {
		this.isLoaded = false;
		this.$store
			.dispatch(LOAD_TRAVEL_REQUEST, params)
			.then(({ totalCount, results }) => {
				if (results.length == 0) return this.$toast.error('Nenhuma viagem encontrada');
				this.totalPages = totalCount;
				let auxHeader = params.colunas.map(column => ({
					...AdvancedFiltersDefinitions[column],
				}));
				auxHeader = auxHeader.filter(
					i => i.key != 'viagem' && i.key != 'ocorrencias' && i.key != 'status',
				);
				auxHeader.push(...this.fixedHeader);
				this.header = auxHeader;
				this.rows = results.map(i => {
					const buttons: Array<string> = [];
					if (this.permissions.includes(this.systemPermissions.TRAVEL_RESUME.SHOW)) {
						buttons.push('detail');
					}
					if (this.permissions.includes(this.systemPermissions.MAP_STATUS.SHOW)) {
						buttons.push('map');
					}
					return {
						...i,
						status: i?.status || '',
						dataPedido: formatDateHour(i.dataPedido),
						chegadaDesembarque: formatDateHour(i.chegadaDesembarque),
						chegadaEmbarque: formatDateHour(i.chegadaEmbarque),
						desembarqueProgramado: formatDateHour(i.desembarqueProgramado),
						embarqueProgramado: formatDateHour(i.embarqueProgramado),
						fimDesembarque: formatDateHour(i.fimDesembarque),
						fimEmbarque: formatDateHour(i.fimEmbarque),
						inicioDesembarque: formatDateHour(i.inicioDesembarque),
						inicioEmbarque: formatDateHour(i.inicioEmbarque),
						saidaDesembarque: formatDateHour(i.saidaDesembarque),
						saidaEmbarque: formatDateHour(i.saidaEmbarque),
						valorPrevisto: formatMoney(i.valorPrevisto),
						peso: formatNumber(i.peso),
						kmRealizado: formatNumber(i.kmRealizado),
						kmEntrePontos: formatNumber(i.kmEntrePontos),
						kmPrevisto: formatNumber(i.kmPrevisto),
						actions: {
							id: i.viagem,
							status: i.status,
							buttons,
						},
					};
				});
			})
			.catch(e => {
				this.$toast.error(e);
			})
			.finally(() => {
				this.isLoaded = true;
			});
	}

	getColumns() {
		this.isLoaded = false;
		this.$store
			.dispatch(GET_COLUMNS)
			.then(response => {
				this.columns = response.filter(i => {
					if (!['Viagem', 'Status', 'Ocorrências'].includes(i.descricao)) {
						return i;
					}
				});
				this.params.colunas = this.columns.filter(i => i.selected).map(i => i.codigo);
			})
			.catch(e => {
				this.$toast.error(e);
			})
			.finally(() => {
				this.getTravels(this.params);
			});
	}

	message(message, variant) {
		this.$nextTick(() => {
			this.$toast.open({
				message,
				type: variant,
			});
		});
	}

	exportXLS() {
		const params = { ...this.params };
		params.size = this.totalPages;
		this.busy.xlsx = true;
		let body = [];
		const header = this.header.map(item => {
			return { label: item?.label || item?.key, value: item?.key };
		});
		header.pop();
		this.$store
			.dispatch(LOAD_TRAVEL_REQUEST, params)
			.then(({ results }) => {
				if (results.length == 0) {
					return;
				}
				body = results.map(i => {
					return {
						...i,
						status: i?.status || '',
						dataPedido: formatDateHour(i.dataPedido),
						chegadaDesembarque: formatDateHour(i.chegadaDesembarque),
						chegadaEmbarque: formatDateHour(i.chegadaEmbarque),
						desembarqueProgramado: formatDateHour(i.desembarqueProgramado),
						embarqueProgramado: formatDateHour(i.embarqueProgramado),
						fimDesembarque: formatDateHour(i.fimDesembarque),
						fimEmbarque: formatDateHour(i.fimEmbarque),
						inicioDesembarque: formatDateHour(i.inicioDesembarque),
						inicioEmbarque: formatDateHour(i.inicioEmbarque),
						saidaDesembarque: formatDateHour(i.saidaDesembarque),
						saidaEmbarque: formatDateHour(i.saidaEmbarque),
						valorPrevisto: formatMoney(i.valorPrevisto),
					};
				});
			})
			.catch(e => {
				this.$toast.error(e);
			})
			.finally(() => {
				this.busy.xlsx = false;
				saveXLSX(header, body, 'tabela', 'Lista-viagens');
			});
	}

	downloadImage(params) {
		this.busy.image = true;
		this.$store
			.dispatch(GET_DOWNLOAD_IMAGE, params)
			.then(() => {
				this.$toast.success('Download realizado com sucesso!');
			})
			.catch(e => {
				this.$toast.error(e);
			})
			.finally(() => {
				this.busy.image = false;
			});
	}

	openDetail(viagem) {
		this.$store.dispatch(SELECT_DETAIL_ORDER, viagem.id);
	}

	openMap(viagem) {
		this.$store.dispatch(SELECT_MAP, viagem.id);
	}

	openModalInterruption(row) {
		this.$store.dispatch(SELECT_TRAVEL_INTERRUPTION, row);
	}
}
